import React, { Component } from 'react';
import { voidCallback } from 'core/utils';
import classNames from 'classnames';
import { IFilterOption } from 'core/redux/features/shared/types';

interface IProps extends IFilterOption<any> {
  onToggle?: (e: React.SyntheticEvent, id: any, isCheck: boolean) => void;
  isCheck: boolean;
  className?: string;
  checkBoxId?: string;
}

export class Checkbox extends Component<IProps> {
  private onToggle = (e: React.SyntheticEvent) => {
    if (this.props.onToggle) {
      this.props.onToggle(e, this.props.id, !this.props.isCheck);
    }
  };

  render() {
    const {
      props: { label, isCheck, checkBoxId, id, className },
    } = this;

    const cid = `${checkBoxId}-${id}`;
    return (
      <div
        className={classNames('control', isCheck && 'is-checked', className)}
      >
        <input
          className="is-checkradio is-bordered is-red-dark is-small"
          type="checkbox"
          name={cid}
          id={cid}
          onChange={this.onToggle}
          checked={isCheck}
        />
        <label
          className={classNames(isCheck && 'is-checked', 'label')}
          htmlFor={cid}
        >
          <span className="label-cb">{label}</span>
        </label>
      </div>
    );
  }
}

const checkbox = (props: IProps) => {};

checkbox.defaultProps = {
  onChange: voidCallback,
  isCheck: false,
};
